import { call, put, takeEvery } from "redux-saga/effects";
import { nganhApi } from "../../../api/category/nganhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmNganhActionIds,
  IDmNganhActionTypes,
} from "../../action-types/category/IDmNganhActions";
import { rootActions } from "../../actions/rootActions";
import { IDmNganh } from "./../../../model/respone/category/IDmNganh";

const mainAction = rootActions.category.nganh;

export function* nganhSaga(): any {
  yield takeEvery(eDmNganhActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmNganhActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmNganhActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(nganhApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.nganh.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.nganh.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDmNganhActionTypes): any {
  let res: IBaseRespone = yield call(nganhApi.SelectAll);
  let payload = action.payload as IDmNganh;
  if (payload.id_nganh) {
    res = yield call(nganhApi.Update, payload);
  } else {
    payload = {
      ...payload,
      id_khoa: 0,
      so_nam_dao_tao: 0,
      stt: 0,
    };
    res = yield call(nganhApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IDmNganhActionTypes): any {
  const res: IBaseRespone = yield call(
    nganhApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
